import {
  WeatherStation,
  WeatherStationObservation,
} from '../../weatherStations.types';
import { useWeatherStation } from '../useWeatherStation';
import { useWeatherStationObservations } from '../useWeatherStationObservations';

type UseWeatherStationWithObservationsProps = {
  id: number;
  start: Date;
  end: Date;
  pollInterval?: number;
  maxResults?: number;
};

type UseWeatherStationWithObservations = {
  weatherStation?: WeatherStation;
  observations: WeatherStationObservation[];
  isLoading: boolean;
  error: Error | null;
};

export const useWeatherStationWithObservations = (
  props: UseWeatherStationWithObservationsProps,
): UseWeatherStationWithObservations => {
  const { id, start, end, pollInterval, maxResults } = props;

  const {
    weatherStation,
    isLoading: isLoadingStation,
    error: weatherStationError,
  } = useWeatherStation({ id });

  const {
    observations,
    isLoading: isLoadingObservations,
    error: observationsError,
  } = useWeatherStationObservations({
    id,
    start,
    end,
    pollInterval,
    maxResults,
  });

  return {
    weatherStation,
    observations,
    isLoading: isLoadingStation || isLoadingObservations,
    error: weatherStationError || observationsError,
  };
};
